import { NgModule, Component } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import {MatCheckboxModule} from '@angular/material/checkbox';
import { LoginComponent } from './components/login/login.component';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import {MatIconModule} from '@angular/material/icon';
import {MatCardModule} from '@angular/material/card';
import {MatTableModule} from '@angular/material/table';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { HeaderComponent } from "./components/header/header.component";
import { NgbModalModule, NgbToastModule } from '@ng-bootstrap/ng-bootstrap';
import { DashboardpageComponent } from './components/dashboardpage/dashboardpage.component';
import {MatChipsModule} from '@angular/material/chips';
import {MatToolbarModule} from '@angular/material/toolbar';
import {MatButtonModule} from '@angular/material/button';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import { GenerateClassificationComponent } from './components/generate-classification/generate-classification.component';
import {MatDialogModule} from '@angular/material/dialog';
import { GenerateDescriptionComponent } from './components/generate-description/generate-description.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {MatAutocompleteModule} from '@angular/material/autocomplete';
import {MatInputModule} from '@angular/material/input';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatTabsModule} from '@angular/material/tabs';
import {MatTooltipModule} from '@angular/material/tooltip';
import {MatSelectModule} from '@angular/material/select';
import { DndDirective } from './dnd.directive';
import { HttpClientModule } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ToastrModule } from 'ngx-toastr';
import { ViewClassificationComponent } from './components/view-classification/view-classification.component';
import { MatPaginatorModule } from '@angular/material/paginator';

import {
  MsalModule,
  MsalService,
  MsalGuard,
  MsalBroadcastService,
  MsalInterceptor
} from '@azure/msal-angular';
import {
  PublicClientApplication,
  InteractionType,
  BrowserCacheLocation
} from '@azure/msal-browser';
import { HTTP_INTERCEPTORS } from '@angular/common/http';

import { environment } from '../environments/environment';

const msalConfig = environment.msalConfig;
const pca = new PublicClientApplication({
  auth: {
     clientId: msalConfig.auth.clientId,
      authority: msalConfig.auth.authority,
      redirectUri: msalConfig.auth.redirectUri,
      navigateToLoginRequestUrl: false,
    // clientId: 'YOUR_CLIENT_ID',
    // authority: 'https://login.microsoftonline.com/YOUR_TENANT_ID',
    // redirectUri: '/',               
    // postLogoutRedirectUri: '/'
  },
  cache: { cacheLocation: BrowserCacheLocation.LocalStorage }
});

// 👉 In MSAL v3+, initialize the application object before use.
if (typeof window !== 'undefined') {
  // If you prefer, move this into APP_INITIALIZER to ensure it completes before bootstrap
  // await pca.initialize();
}
@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    DashboardpageComponent,
    GenerateClassificationComponent,
    GenerateDescriptionComponent,
    ViewClassificationComponent,
    HeaderComponent,
    DndDirective
  ],
  imports: [
    HttpClientModule,
    BrowserModule,
     MsalModule.forRoot(
      pca,                                             // MSAL_INSTANCE
      { interactionType: InteractionType.Redirect },   // MSAL_GUARD_CONFIG
      {
        interactionType: InteractionType.Redirect,     // MSAL_INTERCEPTOR_CONFIG
        protectedResourceMap: new Map([
          ['https://graph.microsoft.com/v1.0/me', ['User.Read']]
        ])
      }
    ),
    AppRoutingModule,
    MatCheckboxModule,
    MatButtonModule,
    MatIconModule,
    MatCardModule,
    MatTableModule,
    NgbModalModule,
    NgbModule,
    NgbToastModule,
    NgbModule,
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatToolbarModule,
    MatProgressBarModule,
    MatChipsModule,
    MatDialogModule,
    MatAutocompleteModule,
    MatTabsModule,
    MatTooltipModule,
    MatSelectModule,
    BrowserAnimationsModule,
    MatPaginatorModule,
    ReactiveFormsModule,
    ToastrModule.forRoot()
],
  providers: [
    provideAnimationsAsync(),
    { provide: HTTP_INTERCEPTORS, useClass: MsalInterceptor, multi: true },
    MsalService, MsalGuard, MsalBroadcastService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
